import { DEMO_PROJECTS } from './demo-data';
import type { ChatMessage, ToolBlock, ToolKind } from './types';
import { nextId } from './chat-engine';

const TOOL_USER_LABEL: Record<ToolKind, (name?: string) => string> = {
  floor_plan: (n) => `Show 2 BHK floor plan${n ? ` for ${n}` : ''}`,
  legal_brief: (n) => `Legal pack & history${n ? ` · ${n}` : ''}`,
  market_trends: (n) => `Area trends${n ? ` · ${n}` : ''}`,
  visit_route: () => 'Show Saturday route on map',
  compare_trends: () => 'Compare trends across shortlisted projects',
};

const TOOL_BOT_INTRO: Record<ToolKind, (name?: string) => string> = {
  floor_plan: (n) =>
    `**2D plan and 3D render** for ${n ?? 'this project'} — switch between the builder floor sheet and the furnished dollhouse view.`,
  legal_brief: (n) =>
    `**Legal & history** for ${n ?? 'this project'} — RERA status, title, and key milestones from the disclosure pack.`,
  market_trends: (n) =>
    `**Micro-market trends** for ${n ?? 'this project'} — 5-year indexed growth vs the belt average.`,
  visit_route: () =>
    'Your **Saturday route** — drive times between shortlisted sites from your start point (demo: Indiranagar).',
  compare_trends: () =>
    '**Trend comparison** across your three matches — CAGR, rental yield, and ₹/sqft vs each micro-market.',
};

export function toolBlock(projectId: string | undefined, kind: ToolKind): ToolBlock {
  const p = projectId ? DEMO_PROJECTS[projectId] : undefined;
  const titles: Record<ToolKind, string> = {
    floor_plan: p ? `${p.name} · pick a unit` : 'Pick a unit',
    legal_brief: p ? `${p.name} · legal pack` : 'Legal pack',
    market_trends: p ? `${p.name} · trends` : 'Market trends',
    visit_route: 'Visit route',
    compare_trends: 'Trend comparison',
  };
  return { kind, projectId, title: titles[kind] };
}

export function messagesForTool(projectId: string | undefined, kind: ToolKind): ChatMessage[] {
  const name = projectId ? DEMO_PROJECTS[projectId]?.name : undefined;
  return [
    { id: nextId(), role: 'user', text: TOOL_USER_LABEL[kind](name) },
    {
      id: nextId(),
      role: 'bot',
      text: TOOL_BOT_INTRO[kind](name),
      toolBlocks: [toolBlock(projectId, kind)],
    },
  ];
}

export function recommendationFollowUp(): ChatMessage {
  return {
    id: nextId(),
    role: 'bot',
    text: 'Open **2D plan** or **3D render** from each card — shareable on WhatsApp.',
  };
}
